export default __webpack_public_path__ + "static/media/Slow_sand_filter.8f3ad12a.jpg";